import type { AutomationConfig } from "@smartsuite/automation-engine-api";
import { useState } from "react";
import { useRootStore } from "../../../../../stores/hooks";
import { StyledDescriptionContainer, TextAreaStyled } from "./style";
import { useEngineClient } from "../../../../../services/engineClient";
import { observer } from "mobx-react-lite";
import { ShowMoreWrapper } from "../../../../../components/ShowMoreWrapper";

export const Description = observer<{
  automation: AutomationConfig;
  isEdit: boolean;
  setIsEdit: (value: boolean) => void;
}>(({ automation, isEdit, setIsEdit }) => {
  const store = useRootStore();
  const engineClient = useEngineClient();

  const [description, setDescription] = useState<string>(
    automation.description,
  );

  const updateDescription = (): void => {
    automation.description = description;
    void engineClient
      .updateAutomation({ automation })
      .then(({ lastUpdated, systemStatus }) => {
        store.automations.updateItem({
          ...automation,
          lastUpdated,
          systemStatus: systemStatus ?? automation.systemStatus,
        });
      });
  };

  return (
    <StyledDescriptionContainer>
      {isEdit ? (
        <TextAreaStyled
          autoHeight
          maxLength={250}
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          value={description}
          onFocus={(e) => {
            const textLength = e.target.value.length;
            e.target.setSelectionRange(textLength, textLength);
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
          placeholder="Enter description"
          onBlur={(e) => {
            updateDescription();
            e.stopPropagation();
            setIsEdit(false);
          }}
          onKeyDown={(e) => {
            if (e.code === "Enter") {
              e.preventDefault();
            }
          }}
          onKeyUp={(e) => {
            if (e.code === "Enter") {
              (e.target as HTMLElement)?.blur();
              e.preventDefault();
            } else if (e.code === "Escape") {
              setDescription(automation.description);
              setTimeout(() => {
                (e.target as HTMLElement)?.blur();
              }, 300);
            }
          }}
          onChange={(event) => {
            setDescription(event.target.value);
          }}
        />
      ) : (
        <ShowMoreWrapper deps={isEdit}>{description}</ShowMoreWrapper>
      )}
    </StyledDescriptionContainer>
  );
});
